module.exports = __webpack_public_path__ + "static/banner_mobile-f506e0e98e8b3fc64c20ae5d841485dc.png";